import type { User } from '../types'
import { hasFinancistAccess } from './roleFinancialAccess'

export const MODULE_DEV_KEYS = {
  fksp: 'module_dev_restrict_fksp',
  dovolena: 'module_dev_restrict_dovolena',
  travel_orders: 'module_dev_restrict_travel_orders',
} as const

/** Prázdné / neznámé = uzavřeno (jako na backendu). */
export function isModuleDevRestricted(settingValue: string | undefined | null): boolean {
  if (settingValue == null || settingValue === '') return true
  const v = String(settingValue).toLowerCase().trim()
  return !['0', 'false', 'off', 'no'].includes(v)
}

export function userBypassesModuleDev(
  module: 'fksp' | 'dovolena' | 'travel_orders',
  user: User | null
): boolean {
  if (!user) return false
  if (user.role === 'admin' && user.admin_type === 'spravce_it') return true
  if (user.role === 'director' || hasFinancistAccess(user)) return true
  if (module === 'travel_orders' && user.role === 'zastupce_reditele') return true
  return false
}

export type ModuleDevFlags = {
  fksp: boolean
  dovolena: boolean
  travel_orders: boolean
}

export function parseModuleDevFlags(settings: Record<string, string>): ModuleDevFlags {
  return {
    fksp: isModuleDevRestricted(settings[MODULE_DEV_KEYS.fksp]),
    dovolena: isModuleDevRestricted(settings[MODULE_DEV_KEYS.dovolena]),
    travel_orders: isModuleDevRestricted(settings[MODULE_DEV_KEYS.travel_orders]),
  }
}
